import React from 'react';
import PropTypes from 'prop-types';
import { Consumer } from '../../../../_views/global_context';
import Station from './finder_station';
import Translation from '../../translation/translation';
import TranslationContainer from '../../translation/translation_container';
import formatToCurrency from "../../../../_modules/currency/format_to_currency";
import { cloneDeep, isEqual, noop } from '../../../../../lib/utilities';

class FinderStationListComponent extends React.Component {
    constructor(props) {
        super(props);

        this.update = false;
        this.state = {
            showAllCosts: cloneDeep(this.props.showAllCosts),
            wheelAlignment: cloneDeep(this.props.wheelAlignment),
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!isEqual({
            showAllCosts: nextProps.showAllCosts,
            wheelAlignment: nextProps.wheelAlignment
        }, {
            showAllCosts: this.state.showAllCosts,
            wheelAlignment: this.state.wheelAlignment
        })) {
            this.update = true;
            this.setState({
                wheelAlignment: cloneDeep(nextProps.wheelAlignment),
                showAllCosts: cloneDeep(nextProps.showAllCosts),
            });
        }
    }

    shouldComponentUpdate(nextProps) {
        var update = this.update;
        this.update = false;

        return update || !isEqual({
            stations: this.props.stations,
            detailModeStation: this.props.detailModeStation,
            activeStation: this.props.activeStation,
            hoveredStation: this.props.hoveredStation,
            loading: this.props.loading
        }, {
            stations: nextProps.stations,
            detailModeStation: nextProps.detailModeStation,
            activeStation: nextProps.activeStation,
            hoveredStation: nextProps.hoveredStation,
            loading: nextProps.loading
        });
    }

    _getStations() {
        const props = this.props;

        return props.stations.map((station) => {
            const key = 'station-' + station.id;
            const isInDetailMode = props.detailModeStation === station.id;
            const isSelected = props.activeStation && props.activeStation.id === station.id;
            const isHovered = props.hoveredStation === station.id;
            const hasWheelAlignment2 = props.wheelAlignment.wheels2.indexOf(station.id) !== -1;
            const hasWheelAlignment4 = props.wheelAlignment.wheels4.indexOf(station.id) !== -1;
            const totals = this._getTotals(station, hasWheelAlignment2, hasWheelAlignment4);
            const serviceTotals = this._getServiceTotals(station);
            const shippingWarning = Object.prototype.hasOwnProperty.call(station, 'shippingWarning')
                && station.shippingWarning !== ''
                ? station.shippingWarning : null;

            const supplierCanHoldStockUntilPickUp = station.supplierCanHoldStockUntilPickUp;
            const deactivatedInFsf = station.deactivatedInFsf;
            const loadingPrices = props.loadingPrices;

            let disableFitter = false;
            let onWheels2Change = props.onWheels2Change;
            let onWheels4Change = props.onWheels4Change;
            let onDetailModeClick = props.onDetailModeClick;
            if (deactivatedInFsf && loadingPrices) {
                onDetailModeClick = noop;
                onWheels2Change = noop;
                onWheels4Change = noop;
            }

            if (deactivatedInFsf && !loadingPrices && !supplierCanHoldStockUntilPickUp) {
                onDetailModeClick = noop;
                onWheels2Change = noop;
                onWheels4Change = noop;
                disableFitter = true;
            }

            return (
                <Station
                    showAllCosts={props.showAllCosts.indexOf(station.id) !== -1}
                    ref={key}
                    showSelectStationButton={props.showSelectStationButton}
                    showDisplayName={props.showDisplayName}
                    showSuccessPage={props.showSuccessPage}
                    key={key}
                    data={station}
                    inDetailMode={isInDetailMode}
                    isSelected={isSelected}
                    isHovered={isHovered}
                    totals={totals}
                    serviceTotals={serviceTotals}
                    productsPrice={props.productsPrice}
                    productsQty={props.productsQty}
                    productBrand={props.productBrand}
                    productModel={props.productModel}
                    productManufacturer={props.productManufacturer}
                    productDimensions={props.productDimensions}
                    wheelAlignment2={hasWheelAlignment2}
                    wheelAlignment4={hasWheelAlignment4}
                    onDetailModeClick={onDetailModeClick}
                    onStationSelect={props.onStationSelect}
                    onListModeClick={props.onListModeClick}
                    onStationHover={props.onStationHover}
                    onStationHoverEnd={props.onStationHoverEnd}
                    onWheels2Change={onWheels2Change}
                    onWheels4Change={onWheels4Change}
                    shippingWarning={shippingWarning}
                    onShowAllCostsClick={(evt) => {
                        evt.stopPropagation();
                        props.onShowAllCostsClick(station.id);
                    }}
                    onHideAllCostsClick={(evt) => {
                        evt.stopPropagation();
                        props.onHideAllCostsClick(station.id);
                    }}
                    onShowMoreWheelAlignmentInfoClick={props.onShowMoreWheelAlignmentInfoClick}
                    staticUrl={props.staticUrl}
                    store={props.store}
                    buy4Pay3={props.buy4Pay3}
                    disableFitter={disableFitter}
                />
            );
        });
    }

    _getTotals(station, hasWheelAlignment2, hasWheelAlignment4) {
        return hasWheelAlignment2 ?
            station.wheelAlignment.wheels_2_totals : hasWheelAlignment4 ?
                station.wheelAlignment.wheels_4_totals :
                station.totalCart;
    }

    _getServiceTotals(station) {
        return formatToCurrency(
            station.individualFittingCost * this.props.productsQty,
            TYROOLA.globals.currencyIsoCode,
            true,
            true
        );
    }

    _getStationsMessage() {
        if (this.props.loading) {
            return this._getStationsLoadingMessage();
        } else {
            return this._getNoStationsMessage();
        }
    }

    _getStationsLoadingMessage() {
        return (
            <div className="no-stations-found">
                <Translation translationKey="fitting-station-finder-app-looking-for-stations" />
            </div>
        );
    }

    _getNoStationsMessage() {
        return (
            <div className="no-stations-found">
                <TranslationContainer
                    translationKeys={{
                        telNumber: 'contact_phone_number',
                        telHref: 'contact_phone_number_link'
                    }}
                    targetProperty="placeholder"
                >
                    <Consumer>{globals => (
                        <Translation
                            translationKey="fitting-station-finder-app-no-stations-found"
                            placeholder={{
                                email: globals.supportEmail,
                            }}
                        />
                    )}</Consumer>
                </TranslationContainer>
            </div>
        );
    }

    scrollToHoveredStation() {
        if (this.refs['station-' + this.props.hoveredStation]
            && this.refs['station-' + this.props.hoveredStation].getPosition()) {
            $(this.refs.stationList).scrollTop(this.refs['station-' + this.props.hoveredStation].getPosition().top);
        }
    }

    render() {
        return (
            <div ref="stationList" className="scrollbar-inner fitting-stations">
                {this.props.stations.length ? this._getStations() : this._getStationsMessage()}
            </div>
        );
    }
}

FinderStationListComponent.propTypes = {
    showSelectStationButton: PropTypes.bool.isRequired,
    onWheels2Change: PropTypes.func.isRequired,
    onWheels4Change: PropTypes.func.isRequired,
    onShowMoreWheelAlignmentInfoClick: PropTypes.func.isRequired,
    wheelAlignment: PropTypes.object.isRequired,
    buy4Pay3: PropTypes.bool,
};

FinderStationListComponent.defaultProps = {
    buy4Pay3: false,
};

export default FinderStationListComponent;
